import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { memo } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './SegmentedControl.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var SegmentedControl = function SegmentedControl(_ref) {
  var segments = _ref.segments,
      selectedIndex = _ref.selectedIndex,
      white = _ref.white;
  var marginCorrect = (segments.length + 1) % 2 !== 0 ? {
    marginRight: -1 * (segments.length - 1)
  } : {};
  return /*#__PURE__*/_jsx("div", {
    className: css.root,
    style: marginCorrect,
    children: segments.map(function (segment, index) {
      var _ref2;

      var segmentClassName = cc([css.segment, (_ref2 = {}, _defineProperty(_ref2, css.white, white), _defineProperty(_ref2, css.on, index === selectedIndex), _ref2)]);
      return /*#__PURE__*/_jsx("button", {
        "aria-label": segment.ariaLabel || segment.label,
        className: segmentClassName,
        onClick: function onClick() {
          segment.onClick();
        },
        type: "button",
        children: segment.label
      }, segment.label);
    })
  });
};

SegmentedControl.defaultProps = {
  white: false
};
SegmentedControl.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedIndex: PropTypes.number.isRequired,
  white: PropTypes.bool
};
export default /*#__PURE__*/memo(SegmentedControl);